import {API_URL, MOKA_SERVICE_URL} from 'api/constants'

export const LIBRARY_TAXES = `${API_URL}/v2/taxes`
export const V1_TAX_BY_ID = (id) => `${API_URL}/v1/taxes/${id}`
export const V1_TAX_URL = `${API_URL}/v1/taxes`
export const TAX_ALL_OUTLET = `${API_URL}/v1/taxes/create_all_outlet`

export const TAXES_SERVICE = () => {
  let service = '/library/v1/taxes'
  return MOKA_SERVICE_URL + service
}

export const ITEMS_SERVICE = () => {
  let service = '/library/v1/items'
  return MOKA_SERVICE_URL + service
}

export const GET_TAX_SERVICE = (outletId) => TAXES_SERVICE() + `?outletId=${outletId}` + '&sort=name,amount,id,asc'
export const GET_TAX_BY_ID_SERVICE = (taxId) => TAXES_SERVICE() + `/${taxId}?deep=false`
export const GET_TAXITEMS_BY_ID_SERVICE = (taxId) => TAXES_SERVICE() + `/${taxId}/items?basic=true&customAmount=false`
export const GET_TAXITEMS_CUSTOM_AMOUNT_BY_ID_SERVICE = (taxId) => TAXES_SERVICE() + `/${taxId}/items?basic=true&customAmount=true`

export const GET_ITEM_SERVICE = (outletId, categoryId, name) => ITEMS_SERVICE() + `?basic=true&unpaged=true&outletId=${outletId}&categoryId=${categoryId}&name=${name}`
export const GET_ITEM_CUSTOM_AMOUNT_SERVICE = (outletId) => ITEMS_SERVICE() + `?basic=true&unpaged=true&customAmount=true&outletId=${outletId}`

export const PUT_TAX_BY_ID_SERVICE = (taxId) => TAXES_SERVICE() + `/${taxId}`
export const POST_TAX_BY_ID_SERVICE = () => TAXES_SERVICE()
export const DELETE_TAX_BY_ID_SERVICE = (taxId) => TAXES_SERVICE() + `/${taxId}`



// WEBPACK FOOTER //
// ./app/api/taxes/constants.js